module.exports = "https://web-assets-production.autolist.com/_next/static/images/sedan-9097eb987b50c2c0079d0c067437c58e.jpg";